import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuSelectionService {
  private selectedItemSubject = new Subject<any>();
  selectedItem$ = this.selectedItemSubject.asObservable();

  selectItem(item: any) {
    this.selectedItemSubject.next(item);
  }
}
